/**
 * ShareBanner Component
 *
 * Displays at the top of shared dashboards to indicate
 * the user is viewing via a share link
 */

import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { HugeiconsIcon } from "@hugeicons/react"
import { Globe02Icon, Link01Icon, ViewIcon } from "@hugeicons/core-free-icons"
import { useShare } from "@/lib/contexts/ShareContext";

export function ShareBanner() {
  const { property } = useShare();
  const domain = property?.domain;

  return (
    <div className="bg-blue-50 dark:bg-blue-950/30 border-b border-blue-200 dark:border-blue-900">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 py-3">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-blue-100 dark:bg-blue-900/50 shrink-0">
              <HugeiconsIcon icon={ViewIcon} size={16} className="text-blue-600 dark:text-blue-400" />
            </div>
            <div className="flex flex-col">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-blue-900 dark:text-blue-100">
                  Shared Dashboard
                </span>
                {domain && (
                  <>
                    <span className="text-blue-400 dark:text-blue-600 text-xs">·</span>
                    <span className="flex items-center gap-1 text-xs font-medium text-blue-700 dark:text-blue-300">
                      <HugeiconsIcon icon={Globe02Icon} size={12} className="text-blue-500 dark:text-blue-400" />
                      {domain}
                    </span>
                  </>
                )}
              </div>
              <p className="text-xs text-blue-600 dark:text-blue-400">
                Read-only view. Some features are disabled.
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              asChild
              className="border-blue-300 dark:border-blue-700"
            >
              <Link to="/auth?mode=signin">
                <HugeiconsIcon icon={Link01Icon} size={16} className="mr-2" />
                Sign in
              </Link>
            </Button>
            <Button size="sm" asChild>
              <Link to="/auth?mode=signup&utm_source=share_banner">Start free trial</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
